/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Cta_TitleInputs */

const en_control_cta_title = /** @type {(inputs: Control_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make the next choice yours.`)
};

const zh_control_cta_title = /** @type {(inputs: Control_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`规划你的下一次选择。`)
};

/**
* | output |
* | --- |
* | "Make the next choice yours." |
*
* @param {Control_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_cta_title = /** @type {((inputs?: Control_Cta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Cta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_cta_title(inputs)
	return zh_control_cta_title(inputs)
});
export { control_cta_title as "control.cta.title" }